import { useEffect, useRef, useState } from "react";

const emptyInvoiceSettings = {
  numbering_start_date: "2026-01-01",
  numbering_prefix: "2026-",
  numbering_next: 1,
  numbering_padding: 4,
  numbering_pattern: "PREFIXNNNN",

  company_name: "",
  company_address_1: "",
  company_address_2: "",
  company_postcode: "",
  company_city: "",
  company_country: "",
  company_email: "",
  company_website: "",
  company_phone: "",
  company_kvk: "",
  company_vat: "",
  company_iban: "",

invoice_title: "Factuur",
invoice_contact_person: "",
payment_text: "",
footer_text: "",

offer_title: "Offerte",
offer_contact_person: "",
offer_company_name: "",
offer_company_address_1: "",
offer_company_address_2: "",
offer_company_postcode: "",
offer_company_city: "",
offer_company_country: "",
offer_company_email: "",
offer_company_website: "",
offer_company_phone: "",
offer_company_kvk: "",
offer_company_vat: "",
offer_company_iban: "",
offer_text: "",
offer_footer_text: "",

logo_url: "",
layout_json: "{}",
};

const emptyCommunicationSettings = {
  email_enabled: true,
  whatsapp_enabled: true,
  sms_enabled: false,
  default_country_code: "+31",
  messagebird_api_key: "",
  bird_workspace_id: "",
  bird_sms_channel_id: "",
  messagebird_originator: "",
  default_sms_text: "",
  default_whatsapp_text: "",
};

const emptyOfferTemplate = {
  id: null,
  name: "",
  template_type: "offer",
  subject: "",
  salutation: "Beste familie,",
  intro_text: "",
  body_text: "",
  conditions_text: "",
  payment_text: "",
  planning_text: "",
  warranty_text: "",
  closing_text: "",
  show_agreement_block: false,
  agreement_text: "Naam:________________________________________\nDatum:_______________________________________",
  active: true,
};

export default function Instellingen() {

const VERSION = "vINS-006";
const API_BASE = "";

function authHeaders(extra = {}) {
  const token =
    sessionStorage.getItem("token") ||
    localStorage.getItem("token") ||
    "";

  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

const rawUser =
  sessionStorage.getItem("user") ||
  localStorage.getItem("user") ||
  "";

function getIsAdmin() {
  try {
    const raw =
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      "";

    if (!raw) return false;

    const user = JSON.parse(raw);

    const roleName = String(user?.role || "").toLowerCase().trim();
    const roleId = String(user?.role_id || "").trim();

    // 🔒 ALLEEN ADMIN IS ADMIN
    if (roleName === "admin" || roleId === "1") {
      return true;
    }

    return false;
  } catch (e) {
    console.log("Fout bij bepalen admin:", e);
    return false;
  }
}

const isAdmin = getIsAdmin();

  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selected, setSelected] = useState(null);

const [view, setView] = useState("general"); // general | documents | communication | invoice | offers | user

  const [flash, setFlash] = useState("");
  const [invoiceFlash, setInvoiceFlash] = useState("");
  const [showPassword, setShowPassword] = useState(false);

const [generalSettings, setGeneralSettings] = useState({
  use_organisations: true,
  use_particulieren: false,
});

const [invoiceSettings, setInvoiceSettings] = useState(emptyInvoiceSettings);
  const [documentLocation, setDocumentLocation] = useState("C:/StaffIQ/Documenten");
  const [communicationSettings, setCommunicationSettings] = useState(emptyCommunicationSettings);
  const [communicationFlash, setCommunicationFlash] = useState("");
  const [offerTemplates, setOfferTemplates] = useState([]);
  const [selectedOfferTemplate, setSelectedOfferTemplate] = useState(emptyOfferTemplate);
  const [templateFlash, setTemplateFlash] = useState("");
  const [saveSuccess, setSaveSuccess] = useState(false);

  const isMobile = window.innerWidth <= 768;
  const detailRef = useRef(null);
  const offerTemplatesSectionRef = useRef(null);

  function scrollToDetailMobile() {
    setTimeout(() => {
      try {
        const detail = detailRef.current;
        if (!detail) return;

        detail.scrollIntoView?.({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });

        if (typeof detail.scrollTo === "function") {
          detail.scrollTo({ top: 0, behavior: "smooth" });
        }
      } catch {}
    }, 120);
  }

  function positionSettingsTop() {
    setTimeout(() => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      } catch {}

      try {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch {}

      try {
        const detail = detailRef.current;
        if (detail && typeof detail.scrollTo === "function") {
          detail.scrollTo({ top: 0, behavior: "smooth" });
        }
      } catch {}
    }, 120);
  }

  function positionOfferTemplatesTop() {
    setTimeout(() => {
      try {
        offerTemplatesSectionRef.current?.scrollIntoView?.({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      } catch {}
    }, 120);
  }

useEffect(() => {
    loadRoles();
    loadUsers();
    loadGeneralSettings();
    loadInvoiceSettings();
    loadDocumentSettings();
    loadCommunicationSettings();
    loadOfferTemplates();
  }, []);

async function loadRoles() {
  const r = await fetch(`${API_BASE}/api/roles`, {
    headers: authHeaders(),
  });

  const data = await r.json().catch(() => []);

  if (!r.ok) {
    console.log("Fout bij laden roles:", data);
    setRoles([]);
    return;
  }

  setRoles(Array.isArray(data) ? data : []);
}

async function loadUsers() {
  try {
    const res = await fetch(`${API_BASE}/api/users`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);

    if (!res.ok) {
      console.log("Fout bij laden users:", data);
      setUsers([]);
      setSelected((prev) => {
        if (!prev) return null;
        return null;
      });
      alert(data?.error || "Fout bij laden users");
      return;
    }

    if (Array.isArray(data)) {
      setUsers(data);

      setSelected((prev) => {
        if (!prev) return null;

        // Nieuwe gebruiker open laten staan
        if (!prev.id) return prev;

        const stillExists = data.find(
          (u) => String(u.id) === String(prev.id)
        );

        if (!stillExists) {
          return null;
        }

        return { ...stillExists, password: "" };
      });
    } else {
      console.log("API /api/users gaf geen array terug:", data);
      setUsers([]);
      setSelected((prev) => {
        if (!prev) return null;
        return null;
      });
      alert("Users konden niet goed worden geladen.");
    }
  } catch (err) {
    console.log("Fout bij laden users:", err);
    setUsers([]);
    setSelected((prev) => {
      if (!prev) return null;
      return null;
    });
    alert("Fout bij laden users");
  }
}

  async function loadInvoiceSettings() {
    try {
const r = await fetch(`${API_BASE}/api/invoice-settings`, {
  headers: authHeaders(),
});
      const data = await r.json();

      setInvoiceSettings({
        ...emptyInvoiceSettings,
        ...(data || {}),
      });
    } catch (err) {
      console.log("Fout bij laden factuurinstellingen:", err);
      alert("Factuurinstellingen konden niet worden geladen.");
    }
  }

async function loadDocumentSettings() {
    try {
const r = await fetch(`${API_BASE}/api/document-settings`, {
  headers: authHeaders(),
});
      const data = await r.json();

      setDocumentLocation(String(data?.document_base_path || "C:/StaffIQ/Documenten"));
    } catch (err) {
      console.log("Fout bij laden documentlocatie:", err);
      alert("Documentlocatie kon niet worden geladen.");
    }
  }

async function loadCommunicationSettings() {
    try {
      const r = await fetch(`${API_BASE}/api/communication-settings`, {
        headers: authHeaders(),
      });

      const data = await r.json().catch(() => ({}));

      if (!r.ok) {
        console.log("Fout bij laden communicatie-instellingen:", data);
        setCommunicationSettings(emptyCommunicationSettings);
        return;
      }

      setCommunicationSettings({
        ...emptyCommunicationSettings,
        ...(data || {}),
        email_enabled: data?.email_enabled !== false,
        whatsapp_enabled: data?.whatsapp_enabled !== false,
        sms_enabled: data?.sms_enabled === true,
        default_country_code: data?.default_country_code || "+31",
        messagebird_api_key: data?.messagebird_api_key || "",
        bird_workspace_id: data?.bird_workspace_id || "",
        bird_sms_channel_id: data?.bird_sms_channel_id || "",
        messagebird_originator: data?.messagebird_originator || "",
        default_sms_text: data?.default_sms_text || "",
        default_whatsapp_text: data?.default_whatsapp_text || "",
      });
    } catch (err) {
      console.log("Fout bij laden communicatie-instellingen:", err);
      setCommunicationSettings(emptyCommunicationSettings);
    }
  }

async function saveCommunicationSettings() {
    if (!isAdmin) {
      alert("Alleen de administrator mag communicatie-instellingen wijzigen.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/communication-settings`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(communicationSettings),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        console.log("Opslaan communicatie-instellingen mislukt:", data);
        alert(data?.error || data?.message || "Opslaan communicatie-instellingen mislukt.");
        return;
      }

      setCommunicationSettings({
        ...emptyCommunicationSettings,
        ...(data || {}),
        email_enabled: data?.email_enabled !== false,
        whatsapp_enabled: data?.whatsapp_enabled !== false,
        sms_enabled: data?.sms_enabled === true,
        default_country_code: data?.default_country_code || "+31",
        messagebird_api_key: data?.messagebird_api_key || "",
        bird_workspace_id: data?.bird_workspace_id || "",
        bird_sms_channel_id: data?.bird_sms_channel_id || "",
        messagebird_originator: data?.messagebird_originator || "",
        default_sms_text: data?.default_sms_text || "",
        default_whatsapp_text: data?.default_whatsapp_text || "",
      });

      setCommunicationFlash("Communicatie-instellingen opgeslagen ✅");
      setTimeout(() => setCommunicationFlash(""), 1800);
    } catch (err) {
      console.log("Fout bij opslaan communicatie-instellingen:", err);
      alert("Opslaan communicatie-instellingen mislukt.");
    }
  }

async function loadGeneralSettings() {
    try {
const r = await fetch(`${API_BASE}/api/general-settings`, {
  headers: authHeaders(),
});
      const data = await r.json().catch(() => ({}));

      setGeneralSettings({
        use_organisations: data?.use_organisations !== false,
        use_particulieren: data?.use_particulieren === true,
      });
    } catch (err) {
      console.log("Fout bij laden algemene instellingen:", err);
      setGeneralSettings({
        use_organisations: true,
        use_particulieren: false,
      });
    }
  }

async function saveGeneralSettings() {
    if (!isAdmin) {
      alert("Alleen de administrator mag instellingen wijzigen.");
      return;
    }

    if (!generalSettings.use_organisations && !generalSettings.use_particulieren) {
      alert("Kies minimaal Organisaties of Particulieren.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/general-settings`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(generalSettings),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        alert(data?.error || "Opslaan algemene instellingen mislukt.");
        return;
      }

      setGeneralSettings({
        use_organisations: data?.use_organisations !== false,
        use_particulieren: data?.use_particulieren === true,
      });

      setFlash("Algemene instellingen opgeslagen ✅");
      setTimeout(() => setFlash(""), 1500);
    } catch (err) {
      console.log("Fout bij opslaan algemene instellingen:", err);
      alert("Opslaan algemene instellingen mislukt.");
    }
  }

async function loadGeneralSettings() {
    try {
const r = await fetch(`${API_BASE}/api/general-settings`, {
  headers: authHeaders(),
});
      const data = await r.json().catch(() => ({}));

      setGeneralSettings({
        use_organisations: data?.use_organisations !== false,
        use_particulieren: data?.use_particulieren === true,
      });
    } catch (err) {
      console.log("Fout bij laden algemene instellingen:", err);
      setGeneralSettings({
        use_organisations: true,
        use_particulieren: false,
      });
    }
  }

async function saveGeneralSettings() {
    if (!isAdmin) {
      alert("Alleen de administrator mag instellingen wijzigen.");
      return;
    }

    if (!generalSettings.use_organisations && !generalSettings.use_particulieren) {
      alert("Kies minimaal Organisaties of Particulieren.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/general-settings`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(generalSettings),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        alert(data?.error || "Opslaan algemene instellingen mislukt.");
        return;
      }

      setGeneralSettings({
        use_organisations: data?.use_organisations !== false,
        use_particulieren: data?.use_particulieren === true,
      });

      setFlash("Algemene instellingen opgeslagen ✅");
      setTimeout(() => setFlash(""), 1500);
    } catch (err) {
      console.log("Fout bij opslaan algemene instellingen:", err);
      alert("Opslaan algemene instellingen mislukt.");
    }
  }

  function newUser() {
    setView("user");
    setSelected({
      id: null,
      display_name: "",
      email: "",
      password: "",
      is_active: true,
      role_id: roles[0]?.id || "",
      role: "",
    });
    setShowPassword(false);
  }

  async function saveUser() {
    const isNew = !selected.id;

const saveRes = await fetch(
  isNew
    ? `${API_BASE}/api/users`
    : `${API_BASE}/api/users/${selected.id}`,
  {
    method: isNew ? "POST" : "PUT",
    headers: authHeaders(),
    body: JSON.stringify(selected),
  }
);

const saveData = await saveRes.json().catch(() => ({}));

if (!saveRes.ok) {
  alert(saveData?.error || "Opslaan gebruiker mislukt");
  return;
}

    setFlash("Opgeslagen ✅");
    setTimeout(() => setFlash(""), 1200);

const res = await fetch(`${API_BASE}/api/users`, {
  headers: authHeaders(),
});
const data = await res.json().catch(() => []);

    if (Array.isArray(data)) {
      setUsers(data);

      const updated = data.find((u) => String(u.id) === String(selected.id));
      if (updated) {
        setSelected({ ...updated, password: "" });
      } else if (isNew) {
        const byEmail = data.find(
          (u) =>
            String(u.email || "").toLowerCase() ===
            String(selected.email || "").toLowerCase()
        );
        if (byEmail) setSelected({ ...byEmail, password: "" });
      }
    } else {
      console.log("API /api/users gaf na opslaan geen array terug:", data);
      setUsers([]);
      alert("Users opnieuw laden ging niet goed.");
    }
  }

function handleLogoUpload(e) {
  const file = e.target.files?.[0];
  if (!file) return;

  const isImage = file.type && file.type.startsWith("image/");
  if (!isImage) {
    alert("Kies een afbeeldingsbestand, bijvoorbeeld png, jpg of svg.");
    return;
  }

  const reader = new FileReader();

  reader.onload = () => {
    const result = String(reader.result || "");
    setInvoiceSettings((prev) => ({
      ...prev,
      logo_url: result,
    }));
  };

  reader.onerror = () => {
    alert("Logo kon niet worden gelezen.");
  };

  reader.readAsDataURL(file);
}

async function saveDocumentSettings() {
    if (!isAdmin) {
      alert("Alleen de administrator mag documentinstellingen wijzigen.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/document-settings`, {
        method: "PUT",
headers: authHeaders(),
        body: JSON.stringify({
          document_base_path: documentLocation,
        }),
      });

      const data = await res.json();

      setDocumentLocation(String(data?.document_base_path || documentLocation));
      setFlash("Documentlocatie opgeslagen ✅");
      setTimeout(() => setFlash(""), 1500);
    } catch (err) {
      console.log("Fout bij opslaan documentlocatie:", err);
      alert("Opslaan van documentlocatie is mislukt.");
    }
  }

async function loadOfferTemplates() {
  try {
    const res = await fetch(`${API_BASE}/api/offer-templates`, {
      headers: authHeaders(),
    });

    const data = await res.json().catch(() => []);

    if (!res.ok) {
      console.log("Fout bij laden offerte-/opdrachtsjablonen:", data);
      setOfferTemplates([]);
      setSelectedOfferTemplate(emptyOfferTemplate);
      return;
    }

    const list = Array.isArray(data) ? data : [];
    setOfferTemplates(list);

    setSelectedOfferTemplate((prev) => {
      if (prev?.id) {
        const stillExists = list.find((x) => String(x.id) === String(prev.id));
        if (stillExists) return stillExists;
      }

      return emptyOfferTemplate;
    });
  } catch (err) {
    console.log("Fout bij laden offerte-/opdrachtsjablonen:", err);
    setOfferTemplates([]);
    setSelectedOfferTemplate(emptyOfferTemplate);
  }
}

function newOfferTemplate() {
  setSelectedOfferTemplate({ ...emptyOfferTemplate });
  setTemplateFlash("");
}

async function saveOfferTemplate() {
  if (!isAdmin) {
    alert("Alleen de administrator mag sjablonen wijzigen.");
    return;
  }

  const name = String(selectedOfferTemplate?.name || "").trim();

  if (!name) {
    alert("Vul eerst een naam voor het sjabloon in.");
    return;
  }

  try {
    const isUpdate = !!selectedOfferTemplate?.id;
    const res = await fetch(
      isUpdate
        ? `${API_BASE}/api/offer-templates/${encodeURIComponent(selectedOfferTemplate.id)}`
        : `${API_BASE}/api/offer-templates`,
      {
        method: isUpdate ? "PUT" : "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          ...selectedOfferTemplate,
          name,
        }),
      }
    );

    const rawText = await res.text();
    let data = {};

    try {
      data = rawText ? JSON.parse(rawText) : {};
    } catch {
      data = { error: rawText || "" };
    }

    if (!res.ok) {
      const message =
        data?.error ||
        data?.message ||
        data?.detail ||
        rawText ||
        `Opslaan van sjabloon is mislukt (${res.status}).`;

      alert(
        `Opslaan van sjabloon is mislukt.\n\n` +
        `Status: ${res.status}\n` +
        `Melding: ${message}`
      );
      return;
    }

    setSelectedOfferTemplate(emptyOfferTemplate);
    await loadOfferTemplates();

    setTemplateFlash("✅ Sjabloon opgeslagen");
    positionOfferTemplatesTop();

    setTimeout(() => setTemplateFlash(""), 1800);
  } catch (err) {
    console.log("Fout bij opslaan sjabloon:", err);
    alert(`Opslaan van sjabloon is mislukt.\n\n${err?.message || err}`);
  }
}

async function deleteOfferTemplate() {
  if (!isAdmin || !selectedOfferTemplate?.id) return;
  if (!window.confirm("Sjabloon verwijderen?")) return;

  try {
    const token =
      sessionStorage.getItem("token") ||
      localStorage.getItem("token") ||
      "";

    const res = await fetch(
      `${API_BASE}/api/offer-templates/${encodeURIComponent(selectedOfferTemplate.id)}`,
      {
        method: "DELETE",
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );

    const rawText = await res.text();
    let data = {};

    try {
      data = rawText ? JSON.parse(rawText) : {};
    } catch {
      data = { error: rawText || "" };
    }

    if (!res.ok) {
      const message =
        data?.error ||
        data?.message ||
        data?.detail ||
        rawText ||
        `Verwijderen van sjabloon is mislukt (${res.status}).`;

      alert(
        `Verwijderen van sjabloon is mislukt.\n\n` +
        `Status: ${res.status}\n` +
        `Melding: ${message}\n` +
        `Detail: ${data?.detail || "-"}\n` +
        `Code: ${data?.code || "-"}\n` +
        `Tabel: ${data?.table || "-"}\n` +
        `Constraint: ${data?.constraint || "-"}`
      );
      return;
    }

    setSelectedOfferTemplate(emptyOfferTemplate);
    await loadOfferTemplates();

    setTemplateFlash("✅ Sjabloon verwijderd");
    positionOfferTemplatesTop();

    setTimeout(() => setTemplateFlash(""), 1800);
  } catch (err) {
    console.log("Fout bij verwijderen sjabloon:", err);
    alert(`Verwijderen van sjabloon is mislukt.\n\n${err?.message || err}`);
  }
}

async function saveInvoiceSettings() {
    if (!isAdmin) {
      alert("Alleen de administrator mag instellingen wijzigen.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/invoice-settings`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(invoiceSettings),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        console.log("Opslaan instellingen mislukt:", data);
        alert(data?.error || data?.message || "Opslaan van instellingen is mislukt.");
        return;
      }

      setInvoiceSettings((prev) => ({
        ...prev,
        ...(data || {}),
      }));

      setInvoiceFlash("✅ Instellingen opgeslagen");
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => setInvoiceFlash(""), 2000);
    } catch (err) {
      console.log("Fout bij opslaan instellingen:", err);
      alert("Opslaan van instellingen is mislukt.");
    }
  }

if (!isAdmin) {
  return (
    <div style={{ padding: 20 }}>
      <h2>Geen toegang</h2>
      <p>Alleen de administrator mag instellingen gebruiken.</p>
    </div>
  );
}

return (
    <div
  style={{
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "320px minmax(0, 1fr)",
    columnGap: 20,
    rowGap: isMobile ? 20 : 0,
    alignItems: "start",
    minWidth: 0,
  }}
>

{/* LINKS - LIJST */}
      <div
  style={{
    width: isMobile ? "100%" : 320,
    minWidth: isMobile ? 0 : 320,
    maxWidth: isMobile ? "100%" : 320,
    background: "white",
    padding: 10,
    boxSizing: "border-box",
  }}
>

<h3>Algemene instellingen</h3>

<button
          onClick={() => {
            setView("general");
            scrollToDetailMobile();
          }}
          style={{
            width: "100%",
            textAlign: "left",
            padding: "10px 12px",
            background: view === "general" ? "#e6f0ff" : "white",
            color: "#111",
            border: "1px solid #d9e2ec",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Organisaties en/of Particulieren
        </button>

        <div
          style={{
            marginTop: 10,
            fontSize: 12,
            opacity: 0.75,
            lineHeight: 1.5,
          }}
        >
          Instelling voor het beheer
          <br />
          van Relaties
        </div>

        <hr style={{ margin: "16px 0" }} />

<h3>Documenten</h3>

<button
          onClick={() => {
            setView("documents");
            scrollToDetailMobile();
          }}
          style={{
            width: "100%",
            textAlign: "left",
            padding: "10px 12px",
            background: view === "documents" ? "#e6f0ff" : "white",
            color: "#111",
            border: "1px solid #d9e2ec",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Locatie
        </button>

        <div
          style={{
            marginTop: 10,
            fontSize: 12,
            opacity: 0.75,
            lineHeight: 1.5,
          }}
        >
          Basispad voor documenten,
          <br />
          bijvoorbeeld C:/StaffIQ/Documenten
        </div>

        <hr style={{ margin: "16px 0" }} />

<h3>Communicatie</h3>

<button
  onClick={() => {
    setView("communication");
    scrollToDetailMobile();
  }}
  style={{
    width: "100%",
    textAlign: "left",
    padding: "10px 12px",
    background: view === "communication" ? "#e6f0ff" : "white",
    color: "#111",
    border: "1px solid #d9e2ec",
    borderRadius: 6,
    cursor: "pointer",
  }}
>
  E-mail / WhatsApp / SMS
</button>

<div
  style={{
    marginTop: 10,
    fontSize: 12,
    opacity: 0.75,
    lineHeight: 1.5,
  }}
>
  Klikbare e-mail,
  <br />
  bellen, WhatsApp en SMS
</div>

<hr style={{ margin: "16px 0" }} />

<h3>Offertes / Opdrachten</h3>

<button
  onClick={() => {
    setView("offers");
    scrollToDetailMobile();
  }}
  style={{
    width: "100%",
    textAlign: "left",
    padding: "10px 12px",
    background: view === "offers" ? "#e6f0ff" : "white",
    color: "#111",
    border: "1px solid #d9e2ec",
    borderRadius: 6,
    cursor: "pointer",
  }}
>
  Offerte-instellingen
</button>

<div
  style={{
    marginTop: 10,
    fontSize: 12,
    opacity: 0.75,
    lineHeight: 1.5,
  }}
>
  Bedrijfsgegevens,
  <br />
  layout-basis en standaardteksten
</div>

<hr style={{ margin: "16px 0" }} />

<h3>Facturen</h3>

<button
  onClick={() => {
    setView("invoice");
    scrollToDetailMobile();
  }}
  style={{
    width: "100%",
    textAlign: "left",
    padding: "10px 12px",
    background: view === "invoice" ? "#e6f0ff" : "white",
    color: "#111",
    border: "1px solid #d9e2ec",
    borderRadius: 6,
    cursor: "pointer",
  }}
>
  Factuurinstellingen
</button>

<div
  style={{
    marginTop: 10,
    fontSize: 12,
    opacity: 0.75,
    lineHeight: 1.5,
  }}
>
  Nummering, bedrijfsgegevens,
  <br />
  layout-basis en standaardteksten
</div>

<hr style={{ margin: "16px 0" }} />

        <h3>Gebruikers</h3>

<button
          onClick={() => {
            newUser();
            scrollToDetailMobile();
          }}
          disabled={!isAdmin}
          style={{
            marginBottom: 12,
            padding: "8px 10px",
            background: "#1f4e79",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: isAdmin ? "pointer" : "not-allowed",
            opacity: isAdmin ? 1 : 0.5,
            width: "100%",
            textAlign: "left",
          }}
        >
          + Nieuwe gebruiker
        </button>

        {Array.isArray(users) &&
          users.map((u) => (
<div
              key={u.id}
onClick={() => {
  console.log("GEKLIKTE USER:", u);
  console.log("USER ID:", u?.id);
  console.log("TYPE USER ID:", typeof u?.id);

  setView("user");
  setSelected({ ...u, password: "" });
  setShowPassword(false);
  scrollToDetailMobile();
}}
              style={{
                padding: "8px",
                cursor: "pointer",
                background:
                  view === "user" && selected?.id === u.id
                    ? "#e6f0ff"
                    : "transparent",
                borderBottom: "1px solid #eee",
              }}
            >
              <b>{u.display_name}</b>
              <br />
              <span style={{ fontSize: 12 }}>{u.email}</span>
            </div>
          ))}
      </div>

{/* RECHTS - DETAIL */}
      <div
  ref={detailRef}
  style={{
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    background: "white",
    padding: isMobile ? 14 : 20,
    boxSizing: "border-box",
  }}
>
{view === "general" ? (
          <>
<h3>Organisaties en/of Particulieren</h3>

            {flash && (
              <div
                style={{
                  marginBottom: 12,
                  padding: "10px 12px",
                  background: "#eaf7ea",
                  color: "#1f6b1f",
                  border: "1px solid #b7dfb7",
                  borderRadius: 6,
                  maxWidth: 700,
                }}
              >
                {flash}
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 14,
                maxWidth: 700,
              }}
            >
              <div
                style={{
                  padding: 12,
                  border: "1px solid #d9e2ec",
                  borderRadius: 6,
                  background: "#fafafa",
                  lineHeight: 1.6,
                }}
              >
                Deze keuze bepaalt de opmaak van de Relatiekaart.
                <br />
                Keuze Organisaties of Particulieren of beiden.
              </div>

              <label
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  cursor: isAdmin ? "pointer" : "not-allowed",
                }}
              >
                <input
                  type="checkbox"
                  checked={generalSettings.use_organisations === true}
                  disabled={!isAdmin}
                  onChange={(e) => {
                    const checked = e.target.checked;

                    if (!checked && !generalSettings.use_particulieren) {
                      alert("Minimaal één keuze is verplicht.");
                      return;
                    }

                    setGeneralSettings((prev) => ({
                      ...prev,
                      use_organisations: checked,
                    }));
                  }}
                />
                <span>Organisaties</span>
              </label>

              <label
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  cursor: isAdmin ? "pointer" : "not-allowed",
                }}
              >
                <input
                  type="checkbox"
                  checked={generalSettings.use_particulieren === true}
                  disabled={!isAdmin}
                  onChange={(e) => {
                    const checked = e.target.checked;

                    if (!checked && !generalSettings.use_organisations) {
                      alert("Minimaal één keuze is verplicht.");
                      return;
                    }

                    setGeneralSettings((prev) => ({
                      ...prev,
                      use_particulieren: checked,
                    }));
                  }}
                />
                <span>Particulieren</span>
              </label>

              <button
                style={{
                  marginTop: 10,
                  padding: "10px",
                  background: "#1f4e79",
                  color: "white",
                  border: "none",
                  cursor: isAdmin ? "pointer" : "not-allowed",
                  borderRadius: 6,
                  width: "fit-content",
                  opacity: isAdmin ? 1 : 0.5,
                }}
                disabled={!isAdmin}
                onClick={saveGeneralSettings}
              >
                Opslaan algemene instellingen
              </button>
            </div>
          </>

) : view === "documents" ? (
          <>
<h3>Documentlocatie</h3>

            {flash && (
              <div
                style={{
                  marginBottom: 12,
                  padding: "10px 12px",
                  background: "#eaf7ea",
                  color: "#1f6b1f",
                  border: "1px solid #b7dfb7",
                  borderRadius: 6,
                  maxWidth: 500,
                }}
              >
                {flash}
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                maxWidth: 700,
              }}
            >
              <label>Basispad documenten</label>
              <input
                value={documentLocation}
                onChange={(e) => setDocumentLocation(e.target.value)}
                placeholder="bijvoorbeeld C:/StaffIQ/Documenten"
              />

              <div
                style={{
                  fontSize: 12,
                  opacity: 0.75,
                  lineHeight: 1.6,
                }}
              >
                Nieuwe documenten worden straks opgeslagen onder dit basispad.
                <br />
                Bijvoorbeeld:
                <br />
                <b>{documentLocation || "C:/StaffIQ/Documenten"}</b>
                <br />
                └── Organisaties
                <br />
                └── Algemeen
              </div>

              <button
                style={{
                  marginTop: 10,
                  padding: "10px",
                  background: "#1f4e79",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: 6,
                  width: "fit-content",
                }}
                onClick={saveDocumentSettings}
              >
                Opslaan documentlocatie
              </button>
            </div>
          </>

) : view === "communication" ? (
  <>
    <h3>Communicatie-instellingen <span style={{ fontSize: 13, color: "#777" }}>{VERSION}</span></h3>

    {communicationFlash && (
      <div
        style={{
          marginBottom: 12,
          padding: "10px 12px",
          background: "#eaf7ea",
          color: "#1f6b1f",
          border: "1px solid #b7dfb7",
          borderRadius: 6,
          maxWidth: 700,
        }}
      >
        {communicationFlash}
      </div>
    )}

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 14,
        maxWidth: 760,
      }}
    >
      <div
        style={{
          padding: 12,
          border: "1px solid #d9e2ec",
          borderRadius: 6,
          background: "#fafafa",
          lineHeight: 1.6,
        }}
      >
        Deze instellingen worden gebruikt voor klikbare communicatie in de middengrids.
        <br />
        E-mail opent het e-mailprogramma. Bellen opent de telefoon-app. WhatsApp opent WhatsApp.
        SMS wordt verstuurd via MessageBird.
      </div>

      <h4 style={{ marginBottom: 0 }}>Activeren</h4>

      <label style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <input
          type="checkbox"
          checked={communicationSettings.email_enabled === true}
          disabled={!isAdmin}
          onChange={(e) =>
            setCommunicationSettings((prev) => ({
              ...prev,
              email_enabled: e.target.checked,
            }))
          }
        />
        <span>E-mail actief</span>
      </label>

      <label style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <input
          type="checkbox"
          checked={communicationSettings.whatsapp_enabled === true}
          disabled={!isAdmin}
          onChange={(e) =>
            setCommunicationSettings((prev) => ({
              ...prev,
              whatsapp_enabled: e.target.checked,
            }))
          }
        />
        <span>WhatsApp actief</span>
      </label>

      <label style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <input
          type="checkbox"
          checked={communicationSettings.sms_enabled === true}
          disabled={!isAdmin}
          onChange={(e) =>
            setCommunicationSettings((prev) => ({
              ...prev,
              sms_enabled: e.target.checked,
            }))
          }
        />
        <span>SMS actief via MessageBird</span>
      </label>

      <hr style={{ width: "100%", border: 0, borderTop: "1px solid #e5e5e5" }} />

      <h4 style={{ marginBottom: 0 }}>Algemeen</h4>

      <label>Standaard landcode</label>
      <input
        value={communicationSettings.default_country_code || ""}
        disabled={!isAdmin}
        onChange={(e) =>
          setCommunicationSettings((prev) => ({
            ...prev,
            default_country_code: e.target.value,
          }))
        }
        placeholder="+31"
      />

      <div style={{ fontSize: 12, opacity: 0.75, lineHeight: 1.5 }}>
        Voor Nederlandse 06-nummers wordt bijvoorbeeld 0612345678 omgezet naar +31612345678.
      </div>

      <hr style={{ width: "100%", border: 0, borderTop: "1px solid #e5e5e5" }} />

<h4 style={{ marginBottom: 0 }}>Bird / MessageBird SMS</h4>

      <label>Bird API key</label>
      <input
        type="password"
        value={communicationSettings.messagebird_api_key || ""}
        disabled={!isAdmin}
        onChange={(e) =>
          setCommunicationSettings((prev) => ({
            ...prev,
            messagebird_api_key: e.target.value,
          }))
        }
        placeholder="Access key van Bird / MessageBird"
      />

      <label>Bird Workspace ID</label>
      <input
        value={communicationSettings.bird_workspace_id || ""}
        disabled={!isAdmin}
        onChange={(e) =>
          setCommunicationSettings((prev) => ({
            ...prev,
            bird_workspace_id: e.target.value,
          }))
        }
        placeholder="Bijv. b182ef56-39ac-42f2-84db-d3d6216a0ad2"
      />

      <label>Bird SMS Channel ID</label>
      <input
        value={communicationSettings.bird_sms_channel_id || ""}
        disabled={!isAdmin}
        onChange={(e) =>
          setCommunicationSettings((prev) => ({
            ...prev,
            bird_sms_channel_id: e.target.value,
          }))
        }
        placeholder="Channel ID van het SMS-kanaal"
      />

      <label>MessageBird afzender / label</label>
      <input
        value={communicationSettings.messagebird_originator || ""}
        disabled={!isAdmin}
        onChange={(e) =>
          setCommunicationSettings((prev) => ({
            ...prev,
            messagebird_originator: e.target.value,
          }))
        }
        placeholder="Optioneel, bijv. StaffIQ"
      />

      <div style={{ fontSize: 12, opacity: 0.75, lineHeight: 1.5 }}>
        Bij de nieuwe Bird API bepaalt het gekozen SMS-kanaal de technische afzender.
        De afzender hierboven wordt bewaard als herkenbaar label.
      </div>

      <label>Standaard SMS-tekst</label>
      <textarea
        value={communicationSettings.default_sms_text || ""}
        disabled={!isAdmin}
        onChange={(e) =>
          setCommunicationSettings((prev) => ({
            ...prev,
            default_sms_text: e.target.value,
          }))
        }
        rows={4}
        placeholder="Bijv. Beste relatie, hierbij een bericht van StaffIQ."
      />

      <hr style={{ width: "100%", border: 0, borderTop: "1px solid #e5e5e5" }} />

      <h4 style={{ marginBottom: 0 }}>WhatsApp</h4>

      <label>Standaard WhatsApp-tekst</label>
      <textarea
        value={communicationSettings.default_whatsapp_text || ""}
        disabled={!isAdmin}
        onChange={(e) =>
          setCommunicationSettings((prev) => ({
            ...prev,
            default_whatsapp_text: e.target.value,
          }))
        }
        rows={4}
        placeholder="Bijv. Beste relatie, hierbij een bericht van StaffIQ."
      />

      <button
        style={{
          marginTop: 10,
          padding: "10px",
          background: "#1f4e79",
          color: "white",
          border: "none",
          cursor: isAdmin ? "pointer" : "not-allowed",
          borderRadius: 6,
          width: "fit-content",
          opacity: isAdmin ? 1 : 0.5,
        }}
        disabled={!isAdmin}
        onClick={saveCommunicationSettings}
      >
        Opslaan communicatie-instellingen
      </button>
    </div>
  </>

) : view === "offers" ? (
  <>
    <h3>Offerte-/Opdrachtinstellingen</h3>

    {invoiceFlash && (
      <div
        style={{
          marginBottom: 12,
          padding: "10px 12px",
          background: "#eaf7ea",
          color: "#1f6b1f",
          border: "1px solid #b7dfb7",
          borderRadius: 6,
          maxWidth: 700,
        }}
      >
        {invoiceFlash}
      </div>
    )}

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile
          ? "1fr"
          : "repeat(2, minmax(280px, 420px))",
        gap: 12,
        alignItems: "start",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
<label>E-mail</label>
        <input
          value={invoiceSettings.offer_company_email || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_email: e.target.value,
            })
          }
        />

        <label>Website</label>
        <input
          value={invoiceSettings.offer_company_website || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_website: e.target.value,
            })
          }
          placeholder="bijv. www.staffiq.nl"
        />

        <label>Telefoon</label>
        <input
          value={invoiceSettings.offer_company_phone || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_phone: e.target.value,
            })
          }
        />

        <label>KvK</label>
        <input
          value={invoiceSettings.offer_company_kvk || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_kvk: e.target.value,
            })
          }
        />

        <label>BTW-nummer</label>
        <input
          value={invoiceSettings.offer_company_vat || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_vat: e.target.value,
            })
          }
        />

        <label>IBAN</label>
        <input
          value={invoiceSettings.offer_company_iban || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_iban: e.target.value,
            })
          }
        />

        <label>Logo upload</label>
        <input
          type="file"
          accept="image/*"
          disabled={!isAdmin}
          onChange={handleLogoUpload}
        />

        <div style={{ fontSize: 12, opacity: 0.75 }}>
          Kies een png, jpg, jpeg of svg bestand vanaf je computer.
        </div>

        {invoiceSettings.logo_url ? (
          <>
            <div style={{ marginTop: 8 }}>
              <img
                src={invoiceSettings.logo_url}
                alt="Logo preview"
                style={{
                  maxWidth: 220,
                  maxHeight: 100,
                  objectFit: "contain",
                  display: "block",
                  border: "1px solid #ddd",
                  padding: 6,
                  background: "#fff",
                }}
              />
            </div>

            <button
              type="button"
              disabled={!isAdmin}
              onClick={() =>
                setInvoiceSettings({
                  ...invoiceSettings,
                  logo_url: "",
                })
              }
              style={{
                marginTop: 8,
                padding: "8px 10px",
                background: "#b02a37",
                color: "white",
                border: "none",
                borderRadius: 6,
                cursor: isAdmin ? "pointer" : "not-allowed",
                opacity: isAdmin ? 1 : 0.5,
                width: "fit-content",
              }}
            >
              Logo verwijderen
            </button>
          </>
        ) : (
          <div style={{ fontSize: 12, opacity: 0.7 }}>
            Nog geen logo gekozen.
          </div>
        )}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <label>Titel</label>
        <input
          value={invoiceSettings.offer_title || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_title: e.target.value,
            })
          }
        />

        <label>Contactpersoon</label>
        <input
          value={invoiceSettings.offer_contact_person || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_contact_person: e.target.value,
            })
          }
        />

        <label>Bedrijfsnaam</label>
        <input
          value={invoiceSettings.offer_company_name || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_name: e.target.value,
            })
          }
        />

        <label>Adresregel 1</label>
        <input
          value={invoiceSettings.offer_company_address_1 || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_address_1: e.target.value,
            })
          }
        />

        <label>Adresregel 2</label>
        <input
          value={invoiceSettings.offer_company_address_2 || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_address_2: e.target.value,
            })
          }
        />

        <label>Postcode</label>
        <input
          value={invoiceSettings.offer_company_postcode || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_postcode: e.target.value,
            })
          }
        />

        <label>Plaats</label>
        <input
          value={invoiceSettings.offer_company_city || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_city: e.target.value,
            })
          }
        />

        <label>Land</label>
        <input
          value={invoiceSettings.offer_company_country || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_company_country: e.target.value,
            })
          }
        />

        <label>Tekst</label>
        <textarea
          rows={4}
          value={invoiceSettings.offer_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_text: e.target.value,
            })
          }
          style={{ resize: "vertical" }}
        />

        <label>Footer tekst</label>
        <textarea
          rows={4}
          value={invoiceSettings.offer_footer_text || ""}
          disabled={!isAdmin}
          onChange={(e) =>
            setInvoiceSettings({
              ...invoiceSettings,
              offer_footer_text: e.target.value,
            })
          }
          style={{ resize: "vertical" }}
        />
      </div>
    </div>

    <div
      style={{
        marginTop: 16,
        paddingTop: 10,
        borderTop: "1px solid #eee",
        display: "flex",
        gap: 10,
      }}
    >
      <button
        onClick={saveInvoiceSettings}
        disabled={!isAdmin}
        style={{
          padding: "10px",
          background: "#1f4e79",
          color: "white",
          border: "none",
          cursor: isAdmin ? "pointer" : "not-allowed",
          borderRadius: 6,
          opacity: isAdmin ? 1 : 0.5,
        }}
      >
        Opslaan offerte-/opdrachtinstellingen
      </button>
    </div>

    <hr style={{ margin: "26px 0 18px 0" }} />

    <h3 ref={offerTemplatesSectionRef}>Offerte-/opdrachtsjablonen</h3>

    {templateFlash && (
      <div
        style={{
          marginBottom: 12,
          padding: "10px 12px",
          background: "#eaf7ea",
          color: "#1f6b1f",
          border: "1px solid #b7dfb7",
          borderRadius: 6,
          maxWidth: 700,
        }}
      >
        {templateFlash}
      </div>
    )}

    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "260px minmax(0, 1fr)",
        gap: 16,
        alignItems: "start",
      }}
    >
      <div
        style={{
          border: "1px solid #d9e2ec",
          borderRadius: 8,
          padding: 10,
          background: "#fff",
        }}
      >
        <button
          type="button"
          onClick={newOfferTemplate}
          disabled={!isAdmin}
          style={{
            width: "100%",
            padding: "9px 10px",
            background: "#1f4e79",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: isAdmin ? "pointer" : "not-allowed",
            opacity: isAdmin ? 1 : 0.5,
            marginBottom: 10,
          }}
        >
          + Nieuw sjabloon
        </button>

        <div style={{ display: "grid", gap: 6 }}>
          {offerTemplates.length === 0 ? (
            <div style={{ fontSize: 13, opacity: 0.7 }}>Nog geen sjablonen.</div>
          ) : (
            offerTemplates.map((tpl) => (
              <button
                key={tpl.id}
                type="button"
                onClick={() => setSelectedOfferTemplate({ ...emptyOfferTemplate, ...tpl })}
                style={{
                  textAlign: "left",
                  padding: "8px 9px",
                  border: "1px solid #d9e2ec",
                  borderRadius: 6,
                  background: String(selectedOfferTemplate?.id || "") === String(tpl.id || "") ? "#e6f0ff" : "#fff",
                  cursor: "pointer",
                }}
              >
                <div style={{ fontWeight: 600 }}>{tpl.name || "(zonder naam)"}</div>
                <div style={{ fontSize: 12, opacity: 0.7 }}>
                  {tpl.template_type === "order" ? "Opdracht" : tpl.template_type === "both" ? "Beide" : "Offerte"}
                  {tpl.active === false ? " · inactief" : ""}
                </div>
              </button>
            ))
          )}
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <label>Naam sjabloon</label>
        <input
          value={selectedOfferTemplate.name || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, name: e.target.value })}
          placeholder="Bijv. Bartels - Offerte PVC Click"
        />

        <label>Type</label>
        <select
          value={selectedOfferTemplate.template_type || "offer"}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, template_type: e.target.value })}
        >
          <option value="offer">Offerte</option>
          <option value="order">Opdrachtbevestiging</option>
          <option value="both">Beide</option>
        </select>

        <label>Onderwerp / betreft-regel</label>
        <input
          value={selectedOfferTemplate.subject || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, subject: e.target.value })}
          placeholder="Bijv. prijsopgave Click pvc-vloer"
        />

        <label>Aanhef</label>
        <input
          value={selectedOfferTemplate.salutation || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, salutation: e.target.value })}
          placeholder="Beste familie,"
        />

        <label>Introductietekst</label>
        <textarea
          rows={5}
          value={selectedOfferTemplate.intro_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, intro_text: e.target.value })}
          style={{ resize: "vertical" }}
        />

        <label>Hoofdtekst / werkzaamheden</label>
        <textarea
          rows={8}
          value={selectedOfferTemplate.body_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, body_text: e.target.value })}
          style={{ resize: "vertical" }}
        />

        <label>Voorwaarden</label>
        <textarea
          rows={6}
          value={selectedOfferTemplate.conditions_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, conditions_text: e.target.value })}
          style={{ resize: "vertical" }}
        />

        <label>Betaling</label>
        <textarea
          rows={4}
          value={selectedOfferTemplate.payment_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, payment_text: e.target.value })}
          style={{ resize: "vertical" }}
        />

        <label>Planning</label>
        <textarea
          rows={4}
          value={selectedOfferTemplate.planning_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, planning_text: e.target.value })}
          style={{ resize: "vertical" }}
        />

        <label>Garantie</label>
        <textarea
          rows={4}
          value={selectedOfferTemplate.warranty_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, warranty_text: e.target.value })}
          style={{ resize: "vertical" }}
        />

        <label>Afsluiting</label>
        <textarea
          rows={4}
          value={selectedOfferTemplate.closing_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, closing_text: e.target.value })}
          style={{ resize: "vertical" }}
        />

        <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <input
            type="checkbox"
            checked={selectedOfferTemplate.show_agreement_block === true}
            disabled={!isAdmin}
            onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, show_agreement_block: e.target.checked })}
          />
          Akkoordblok tonen
        </label>

        <label>Akkoordtekst</label>
        <textarea
          rows={4}
          value={selectedOfferTemplate.agreement_text || ""}
          disabled={!isAdmin}
          onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, agreement_text: e.target.value })}
          style={{ resize: "vertical" }}
        />

        <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <input
            type="checkbox"
            checked={selectedOfferTemplate.active !== false}
            disabled={!isAdmin}
            onChange={(e) => setSelectedOfferTemplate({ ...selectedOfferTemplate, active: e.target.checked })}
          />
          Actief
        </label>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 10 }}>
          <button
            type="button"
            onClick={saveOfferTemplate}
            disabled={!isAdmin}
            style={{
              padding: "10px",
              background: "#1f4e79",
              color: "white",
              border: "none",
              cursor: isAdmin ? "pointer" : "not-allowed",
              borderRadius: 6,
              opacity: isAdmin ? 1 : 0.5,
            }}
          >
            Opslaan sjabloon
          </button>

          <button
            type="button"
            onClick={deleteOfferTemplate}
            disabled={!isAdmin || !selectedOfferTemplate?.id}
            style={{
              padding: "10px",
              background: "#b02a37",
              color: "white",
              border: "none",
              cursor: isAdmin && selectedOfferTemplate?.id ? "pointer" : "not-allowed",
              borderRadius: 6,
              opacity: isAdmin && selectedOfferTemplate?.id ? 1 : 0.5,
            }}
          >
            Verwijderen
          </button>
        </div>
      </div>
    </div>
  </>

        ) : view === "invoice" ? (
          <>
            <h3>Factuurinstellingen</h3>

            {invoiceFlash && (
              <div
                style={{
                  marginBottom: 12,
                  padding: "10px 12px",
                  background: "#eaf7ea",
                  color: "#1f6b1f",
                  border: "1px solid #b7dfb7",
                  borderRadius: 6,
                  maxWidth: 700,
                }}
              >
                {invoiceFlash}
              </div>
            )}

            {!isAdmin && (
              <div
                style={{
                  marginBottom: 12,
                  padding: "10px 12px",
                  background: "#fff7e6",
                  color: "#8a5a00",
                  border: "1px solid #f2d38a",
                  borderRadius: 6,
                  maxWidth: 700,
                }}
              >
                Alleen de administrator mag deze instellingen wijzigen.
              </div>
            )}

<div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile
                  ? "1fr"
                  : "repeat(2, minmax(280px, 420px))",
                gap: 12,
                alignItems: "start",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <label>Startdatum nummerreeks</label>
                <input
                  type="date"
                  value={invoiceSettings.numbering_start_date || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      numbering_start_date: e.target.value,
                    })
                  }
                />

                <label>Prefix</label>
                <input
                  value={invoiceSettings.numbering_prefix || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      numbering_prefix: e.target.value,
                    })
                  }
                  placeholder="bijv. 2026- of SIQ26-"
                />

                <label>Volgend nummer</label>
                <input
                  type="number"
                  value={invoiceSettings.numbering_next || 1}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      numbering_next: Number(e.target.value || 1),
                    })
                  }
                />

                <label>Aantal cijfers (padding)</label>
                <input
                  type="number"
                  value={invoiceSettings.numbering_padding || 4}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      numbering_padding: Number(e.target.value || 4),
                    })
                  }
                />

                <label>Patroon</label>
                <input
                  value={invoiceSettings.numbering_pattern || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      numbering_pattern: e.target.value,
                    })
                  }
                  placeholder="bijv. PREFIXNNNN"
                />

                <div
                  style={{
                    marginTop: 6,
                    fontSize: 12,
                    opacity: 0.75,
                    lineHeight: 1.5,
                  }}
                >
                  Voorbeeld:
                  <br />
                  Prefix = <b>2026-</b>, padding = <b>4</b>, volgend nummer ={" "}
                  <b>1</b>
                  <br />
                  wordt: <b>2026-0001</b>
                </div>
              </div>

<div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <label>Factuurtitel</label>
                <input
                  value={invoiceSettings.invoice_title || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      invoice_title: e.target.value,
                    })
                  }
                />

                <label>Contactpersoon</label>
                <input
                  value={invoiceSettings.invoice_contact_person || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      invoice_contact_person: e.target.value,
                    })
                  }
                />

                <label>Bedrijfsnaam</label>
                <input
                  value={invoiceSettings.company_name || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_name: e.target.value,
                    })
                  }
                />

                <label>Adresregel 1</label>
                <input
                  value={invoiceSettings.company_address_1 || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_address_1: e.target.value,
                    })
                  }
                />

                <label>Adresregel 2</label>
                <input
                  value={invoiceSettings.company_address_2 || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_address_2: e.target.value,
                    })
                  }
                />

                <label>Postcode</label>
                <input
                  value={invoiceSettings.company_postcode || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_postcode: e.target.value,
                    })
                  }
                />

                <label>Plaats</label>
                <input
                  value={invoiceSettings.company_city || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_city: e.target.value,
                    })
                  }
                />

                <label>Land</label>
                <input
                  value={invoiceSettings.company_country || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_country: e.target.value,
                    })
                  }
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
<label>E-mail</label>
                <input
                  value={invoiceSettings.company_email || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_email: e.target.value,
                    })
                  }
                />

                <label>Website</label>
                <input
                  value={invoiceSettings.company_website || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_website: e.target.value,
                    })
                  }
                  placeholder="bijv. www.staffiq.nl"
                />

                <label>Telefoon</label>
                <input
                  value={invoiceSettings.company_phone || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_phone: e.target.value,
                    })
                  }
                />

                <label>KvK</label>
                <input
                  value={invoiceSettings.company_kvk || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_kvk: e.target.value,
                    })
                  }
                />

                <label>BTW-nummer</label>
                <input
                  value={invoiceSettings.company_vat || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_vat: e.target.value,
                    })
                  }
                />

                <label>IBAN</label>
                <input
                  value={invoiceSettings.company_iban || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      company_iban: e.target.value,
                    })
                  }
                />

<label>Logo upload</label>

<input
  type="file"
  accept="image/*"
  disabled={!isAdmin}
  onChange={handleLogoUpload}
/>

<div style={{ fontSize: 12, opacity: 0.75 }}>
  Kies een png, jpg, jpeg of svg bestand vanaf je computer.
</div>

{invoiceSettings.logo_url ? (
  <>
    <div style={{ marginTop: 8 }}>
      <img
        src={invoiceSettings.logo_url}
        alt="Logo preview"
        style={{
          maxWidth: 220,
          maxHeight: 100,
          objectFit: "contain",
          display: "block",
          border: "1px solid #ddd",
          padding: 6,
          background: "#fff",
        }}
      />
    </div>

    <button
      type="button"
      disabled={!isAdmin}
      onClick={() =>
        setInvoiceSettings({
          ...invoiceSettings,
          logo_url: "",
        })
      }
      style={{
        marginTop: 8,
        padding: "8px 10px",
        background: "#b02a37",
        color: "white",
        border: "none",
        borderRadius: 6,
        cursor: isAdmin ? "pointer" : "not-allowed",
        opacity: isAdmin ? 1 : 0.5,
        width: "fit-content",
      }}
    >
      Logo verwijderen
    </button>
  </>
) : (
  <div style={{ fontSize: 12, opacity: 0.7 }}>
    Nog geen logo gekozen.
  </div>
)}
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <label>Betaaltekst</label>
                <textarea
                  rows={4}
                  value={invoiceSettings.payment_text || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      payment_text: e.target.value,
                    })
                  }
                  style={{ resize: "vertical" }}
                />

                <label>Footer tekst</label>
                <textarea
                  rows={4}
                  value={invoiceSettings.footer_text || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      footer_text: e.target.value,
                    })
                  }
                  style={{ resize: "vertical" }}
                />

                <label>Layout JSON</label>
                <textarea
                  rows={6}
                  value={invoiceSettings.layout_json || "{}"}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setInvoiceSettings({
                      ...invoiceSettings,
                      layout_json: e.target.value,
                    })
                  }
                  style={{ resize: "vertical", fontFamily: "monospace" }}
                />
              </div>
            </div>

            <div
              style={{
                marginTop: 16,
                paddingTop: 10,
                borderTop: "1px solid #eee",
                display: "flex",
                gap: 10,
              }}
            >
              <button
                onClick={saveInvoiceSettings}
                disabled={!isAdmin}
                style={{
                  padding: "10px",
                  background: "#1f4e79",
                  color: "white",
                  border: "none",
                  cursor: isAdmin ? "pointer" : "not-allowed",
                  borderRadius: 6,
                  opacity: isAdmin ? 1 : 0.5,
                }}
              >
                Opslaan factuurinstellingen
              </button>
            </div>
          </>
        ) : !selected ? (
          <p>Selecteer een gebruiker</p>
        ) : (
          <>
            <h3>{selected.display_name || "Nieuwe gebruiker"}</h3>

            {flash && (
              <div
                style={{
                  marginBottom: 12,
                  padding: "10px 12px",
                  background: "#eaf7ea",
                  color: "#1f6b1f",
                  border: "1px solid #b7dfb7",
                  borderRadius: 6,
                  maxWidth: 400,
                }}
              >
                {flash}
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                maxWidth: 400,
              }}
            >
              <label>Naam</label>
              <input
                value={selected.display_name || ""}
                disabled={!isAdmin}
                onChange={(e) =>
                  setSelected({ ...selected, display_name: e.target.value })
                }
              />

              <label>Email</label>
              <input
                value={selected.email || ""}
                disabled={!isAdmin}
                onChange={(e) =>
                  setSelected({ ...selected, email: e.target.value })
                }
              />

              <label>Wachtwoord</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  value={selected.password || ""}
                  disabled={!isAdmin}
                  onChange={(e) =>
                    setSelected({ ...selected, password: e.target.value })
                  }
                  style={{ width: "100%", paddingRight: "40px" }}
                />

                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: 14,
                    color: "#666",
                  }}
                >
                  {showPassword ? "🙈" : "👁"}
                </span>
              </div>

              <label>Actief</label>
              <select
                value={selected.is_active ? "1" : "0"}
                disabled={!isAdmin}
                onChange={(e) =>
                  setSelected({
                    ...selected,
                    is_active: e.target.value === "1",
                  })
                }
              >
                <option value="1">Ja</option>
                <option value="0">Nee</option>
              </select>

              <label>Rol</label>
              <select
                value={selected.role_id || ""}
                disabled={!isAdmin}
                onChange={(e) =>
                  setSelected({ ...selected, role_id: e.target.value })
                }
              >
                {roles.map((r) => (
                  <option key={r.id} value={r.id}>
                    {r.name}
                  </option>
                ))}
              </select>

<div style={{ display: "flex", gap: 10, marginTop: 10 }}>
  <button
    onClick={saveUser}
    disabled={!isAdmin}
    style={{
      padding: "10px",
      background: "#1f4e79",
      color: "white",
      border: "none",
      cursor: isAdmin ? "pointer" : "not-allowed",
      borderRadius: 6,
      opacity: isAdmin ? 1 : 0.5,
    }}
  >
    Opslaan
  </button>

{selected?.id && (
  <button
    onClick={async () => {
      if (!window.confirm("Weet je zeker dat je deze gebruiker wilt verwijderen?")) {
        return;
      }

      try {
const token =
  sessionStorage.getItem("token") ||
  localStorage.getItem("token") ||
  "";

const res = await fetch(`${API_BASE}/api/users/${selected.id}`, {
  method: "DELETE",
  headers: {
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  }
});

        const rawText = await res.text();
        let data = {};

        try {
          data = rawText ? JSON.parse(rawText) : {};
        } catch {
          data = { error: rawText || "" };
        }

if (!res.ok) {
  const message =
    data?.error ||
    data?.message ||
    data?.detail ||
    `Verwijderen mislukt (${res.status})`;

  console.log("Delete user fout status:", res.status);
  console.log("Delete user fout data:", data);
  console.log("Delete user fout rawText:", rawText);

  // Als de user al weg is, ook direct uit de lijst halen
  if (res.status === 404) {
    setUsers((prev) =>
      (prev || []).filter((u) => String(u.id) !== String(selected.id))
    );

    setSelected(null);

    setFlash("Gebruiker was al verwijderd ✅");
    setTimeout(() => setFlash(""), 2000);

    setTimeout(() => {
      loadUsers();
    }, 300);

    return;
  }

  alert(
    `Verwijderen mislukt.\n\n` +
    `Status: ${res.status}\n` +
    `Melding: ${message}\n` +
    `Detail: ${data?.detail || "-"}\n` +
    `Code: ${data?.code || "-"}\n` +
    `Tabel: ${data?.table || "-"}\n` +
    `Constraint: ${data?.constraint || "-"}`
  );
  return;
}

// direct uit lijst verwijderen (sneller en zeker)
setUsers((prev) =>
  (prev || []).filter((u) => String(u.id) !== String(selected.id))
);

setSelected(null);

setFlash("Gebruiker verwijderd ✅");
setTimeout(() => setFlash(""), 2000);

// extra zekerheid: daarna opnieuw laden
setTimeout(() => {
  loadUsers();
}, 300);
      } catch (err) {
        console.log("Delete user catch:", err);
        alert(`Fout bij verwijderen: ${err?.message || "onbekend"}`);
      }
    }}
    disabled={!isAdmin}
    style={{
      padding: "10px",
      background: "#b02a37",
      color: "white",
      border: "none",
      cursor: isAdmin ? "pointer" : "not-allowed",
      borderRadius: 6,
      opacity: isAdmin ? 1 : 0.5,
    }}
  >
    Verwijderen
  </button>
)}
</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}